module.exports = __webpack_public_path__ + "static/img/81-2.b17ddc3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/81-2.jpg
// module id = TKpp
// module chunks = 0